import { resolveApiBase, resolveRuntimeBase, type LoaderScriptLike } from './loaderUtils';

export type LoaderScript = LoaderScriptLike & {
  dataset: LoaderScriptLike['dataset'] & {
    integration?: string;
  };
};

export function loadFitting(runtimeBase: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.QformFitting?.open) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `${runtimeBase}/fitting.js`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load fitting.js'));
    document.head.appendChild(script);
  });
}

export function startLoader(script: LoaderScript | null): void {
  if (!script) {
    return;
  }

  const integrationCode = script.dataset.integration ?? '';
  const apiBaseUrl = resolveApiBase(script);
  const runtimeBase = resolveRuntimeBase(script);

  void loadFitting(runtimeBase)
    .then(() => {
      window.QformFitting?.init({ apiBaseUrl, integrationCode, runtimeBase });
      window.QformFitting?.bindTriggers(integrationCode);
    })
    .catch((error) => {
      console.error('[QformFitting loader]', error);
    });
}
